import React from 'react';
import ReactDOM from 'react-dom/client';
import './design/ds/styles.css';
import './design/theme.css';
import { App } from './design/shell.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
